import type { Occupation } from "@/common/types/occupation";
import { referenceClient } from "@/lib/orpc/client";

export const getOccupations = async (): Promise<Occupation[]> => {
  const response = await referenceClient.occupations({});
  return response.items;
};
